// extracted by mini-css-extract-plugin
export default {"breadcrumbMenuContainer":"styles_breadcrumbMenuContainer__zGxXk"};